/** Permanent public notebook id length (route: `/p/{id}`). */
export const PUBLIC_SHORT_ID_LENGTH = 7;

const ID_PATTERN = new RegExp(`^[a-z0-9]{${PUBLIC_SHORT_ID_LENGTH}}$`, "i");

/** Normalize `/p/[segment]` → canonical short id when possible. */
export function parsePublicId(segment: string): {
  shortId: string | null;
  legacyKey: string;
} {
  const legacyKey = decodeURIComponent(segment.trim()).toLowerCase();
  if (!legacyKey) return { shortId: null, legacyKey: "" };

  if (ID_PATTERN.test(legacyKey)) {
    return { shortId: legacyKey, legacyKey };
  }

  const dual = legacyKey.match(/-([a-z0-9]{7})$/i);
  if (dual) {
    return { shortId: dual[1].toLowerCase(), legacyKey };
  }

  return { shortId: null, legacyKey };
}

export function isPublicShortId(value: string): boolean {
  return ID_PATTERN.test(value.trim());
}
